import { Input, type InputProps } from "antd";
import clsx from "clsx";
import "./BInputPassword.scss";

const BInputPassword = ({ className, ...props }: InputProps) => (
  <Input.Password className={clsx("b-input-password", className)} {...props} />
);

export default BInputPassword;
